import type { ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import LineItemSummaryService from '@/Services/CampaignManagement/LineItemSummary.service';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import InfoTable from './InfoTable';

const FrequencyCapsInfo = memo(() => {
  const { getValues } = useFormContext<ILineItemForm>();
  const rows = LineItemSummaryService.getFrequencyCapsInfo(getValues());

  if (!rows?.length) {
    return null;
  }

  return <InfoTable caption='Frequency Caps' rows={rows} />;
});

export default FrequencyCapsInfo;
